<script setup>
import { ref } from 'vue';
import { fetchAsset } from '../loadData';

const termsOfService = ref('Loading...');

(async function getAsset() {
  try {
    termsOfService.value = await fetchAsset('../legal/terms.partial.html');
    console.log(termsOfService.value.slice(0,15) === '<!DOCTYPE html>'
      ? '⚠️ incorrectly fetched the index page'
      : '✅ fetch succeeded');
  } catch (error) {
    console.error('❌ Failed to load ToS:', error);
    termsOfService.value = 'Failed to load ToS.';
  }
})();
</script>

<template>
  <div>
    <div v-html="termsOfService"></div>
  </div>
</template>

<style lang="scss">

</style>
